module.exports = __webpack_public_path__ + "img/icon-lock-wide.503ebf76.svg";